// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Using UAR Professional Theme Variables */
html, body, #root {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--font-family-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--background-secondary);
  color: var(--text-primary);
}

code {
  font-family: var(--font-family-mono);
}

/* Portal Modal Override - Prevent any CSS interference */
.uar-portal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
}

.uar-portal-content {
  position: relative !important;
  transform: none !important;
}

.uar-modal-inner {
  position: static !important;
  transform: none !important;
}

/* Bootstrap Modal Fix - Ensure proper centering and positioning */
/* This MUST come after Bootstrap CSS loads to override correctly */
.modal.fade.show.d-block {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  outline: 0 !important;
  z-index: 1055 !important;
  display: block !important;
  /* Remove any transform that might shift the modal */
  transform: none !important;
}

.modal.fade.show.d-block .modal-dialog {
  position: relative !important;
  width: auto !important;
  margin: 1.75rem auto !important;
  pointer-events: none !important;
  transform: none !important;
}

.modal.fade.show.d-block .modal-dialog.modal-lg {
  max-width: 800px !important;
}

.modal.fade.show.d-block .modal-dialog.modal-xl {
  max-width: 1140px !important;
}

.modal.fade.show.d-block .modal-content {
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  pointer-events: auto !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 0.5rem !important;
  outline: 0 !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5) !important;
}

/* Override Bootstrap primary color to match UAR theme */
.btn-primary {
  background-color: var(--primary-600) !important;
  border-color: var(--primary-600) !important;
}

.btn-primary:hover {
  background-color: var(--primary-700) !important;
  border-color: var(--primary-700) !important;
}

.btn-success {
  background-color: var(--success) !important;
  border-color: var(--success) !important;
}

.btn-danger {
  background-color: var(--danger) !important;
  border-color: var(--danger) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yDAAyD;AACzD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,kEAAkE;AAClE,mEAAmE;AACnE;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,+CAA+C;EAC/C,gCAAgC;EAChC,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA,wDAAwD;AACxD;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC","sourcesContent":["/* Using UAR Professional Theme Variables */\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  font-family: var(--font-family-sans);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--background-secondary);\n  color: var(--text-primary);\n}\n\ncode {\n  font-family: var(--font-family-mono);\n}\n\n/* Portal Modal Override - Prevent any CSS interference */\n.uar-portal-overlay {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  transform: none !important;\n}\n\n.uar-portal-content {\n  position: relative !important;\n  transform: none !important;\n}\n\n.uar-modal-inner {\n  position: static !important;\n  transform: none !important;\n}\n\n/* Bootstrap Modal Fix - Ensure proper centering and positioning */\n/* This MUST come after Bootstrap CSS loads to override correctly */\n.modal.fade.show.d-block {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  outline: 0 !important;\n  z-index: 1055 !important;\n  display: block !important;\n  /* Remove any transform that might shift the modal */\n  transform: none !important;\n}\n\n.modal.fade.show.d-block .modal-dialog {\n  position: relative !important;\n  width: auto !important;\n  margin: 1.75rem auto !important;\n  pointer-events: none !important;\n  transform: none !important;\n}\n\n.modal.fade.show.d-block .modal-dialog.modal-lg {\n  max-width: 800px !important;\n}\n\n.modal.fade.show.d-block .modal-dialog.modal-xl {\n  max-width: 1140px !important;\n}\n\n.modal.fade.show.d-block .modal-content {\n  position: relative !important;\n  display: flex !important;\n  flex-direction: column !important;\n  width: 100% !important;\n  pointer-events: auto !important;\n  background-color: #fff !important;\n  background-clip: padding-box !important;\n  border: 1px solid rgba(0, 0, 0, 0.2) !important;\n  border-radius: 0.5rem !important;\n  outline: 0 !important;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5) !important;\n}\n\n/* Override Bootstrap primary color to match UAR theme */\n.btn-primary {\n  background-color: var(--primary-600) !important;\n  border-color: var(--primary-600) !important;\n}\n\n.btn-primary:hover {\n  background-color: var(--primary-700) !important;\n  border-color: var(--primary-700) !important;\n}\n\n.btn-success {\n  background-color: var(--success) !important;\n  border-color: var(--success) !important;\n}\n\n.btn-danger {\n  background-color: var(--danger) !important;\n  border-color: var(--danger) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
